import { createActionCreator } from '../../../includes/enhanced-reducer';

export interface ISetSortPayload {
    sort: string;
}

const SET_SORT = 'SET_SORT';

export const setSort = createActionCreator<ISetSortPayload>(SET_SORT);
